import { type LatLngBoundsExpression, type LatLngTuple } from 'leaflet'
import React from 'react'
import { ClientOnly } from 'remix-utils/client-only'
import LeafletMap, {
	type MarkerData,
} from '#app/components/leaflet-map.client.tsx'

interface MapProps {
	center: LatLngTuple
	bounds: LatLngBoundsExpression
	markers: MarkerData[]
}

const Map: React.FC<MapProps> = ({ center, bounds, markers }) => {
	return (
		<div className="h-full w-full">
			<ClientOnly
				fallback={
					<div
						id="skeleton"
						style={{ height: '100%', background: '#d1d1d1' }}
					/>
				}
			>
				{() => (
					<LeafletMap
						className="h-full w-full"
						center={center}
						bounds={bounds}
						markers={markers}
						positions={[]}
						navigateTo={console.error}
					/>
				)}
			</ClientOnly>
		</div>
	)
}

export default Map
